module.exports = __webpack_public_path__ + "img/USER_PORTAL.87e0f537.svg";